module.exports = __webpack_public_path__ + "static/media/share.d6957754.svg";